import React, {
  useEffect,
  useState
} from "react";

import {
  auth
} from "../firebase";
import {
  getStorage,
  ref,
  getDownloadURL
} from "firebase/storage";
const API_BASE =
  "https://sellerproxy-898712575285.us-central1.run.app";

export default function GalleryMyImages({
  user
}) {

  const [items, setItems] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  // Edit state
  const [editId, setEditId] =
    useState("");

  const [editTitle, setEditTitle] =
    useState("");

  const [editDescription, setEditDescription] =
    useState("");

  const [editGalleryId, setEditGalleryId] =
    useState("");

  const [editCategoryId, setEditCategoryId] =
    useState("");

  const [editSubcategoryId, setEditSubcategoryId] =
    useState("");

  const [editCategories, setEditCategories] =
    useState([]);

  const [editSubcategories, setEditSubcategories] =
    useState([]);

  const [savingEdit, setSavingEdit] =
    useState(false);

  // Filter state
  const [galleryFilter, setGalleryFilter] =
    useState("");

  const [categoryFilter, setCategoryFilter] =
    useState("");

  const [subcategoryFilter, setSubcategoryFilter] =
    useState("");
const [statusFilter, setStatusFilter] =
  useState("");

const [search, setSearch] =
  useState("");
  

  // Galleries for filter dropdowns
  const [galleries, setGalleries] =
    useState([]);

  const [filterCategories, setFilterCategories] =
    useState([]);

  const [filterSubcategories, setFilterSubcategories] =
    useState([]);

  // Carousel state: { [itemId]: currentIndex }
  const [carouselIndex, setCarouselIndex] =
    useState({});
const [imageUrlsMap, setImageUrlsMap] =
  useState({});
  useEffect(() => {
    if (user?.uid) {
      loadImages();
      loadGalleries();
    }
  }, [user]);

  useEffect(() => {
    if (galleryFilter) {
      loadFilterCategories(galleryFilter);
    } else {
      setFilterCategories([]);
      setCategoryFilter("");
      setFilterSubcategories([]);
      setSubcategoryFilter("");
    }
  }, [galleryFilter]);

  useEffect(() => {
    if (categoryFilter) {
      loadFilterSubcategories(categoryFilter);
    } else {
      setFilterSubcategories([]);
      setSubcategoryFilter("");
    }
  }, [categoryFilter]);

  useEffect(() => {
    if (editGalleryId) {
      loadEditCategories(editGalleryId);
    } else {
      setEditCategories([]);
      setEditCategoryId("");
      setEditSubcategories([]);
      setEditSubcategoryId("");
    }
  }, [editGalleryId]);

  useEffect(() => {
    if (editCategoryId) {
      loadEditSubcategories(editCategoryId);
    } else {
      setEditSubcategories([]);
      setEditSubcategoryId("");
    }
  }, [editCategoryId]);

  async function getAuthHeaders() {
    const currentUser = auth.currentUser;
    if (!currentUser) {
      throw new Error("Please sign in first");
    }
    const token = await currentUser.getIdToken(true);
    return {
      "X-Firebase-Authorization": `Bearer ${token}`
    };
  }

  const loadImages = async () => {
    try {
      const headers = await getAuthHeaders();
      const response = await fetch(
        `${API_BASE}/api/gallery/my-images`,
        { headers }
      );
      const data = await response.json();
      if (!response.ok) {
        throw new Error(
          data?.message ||
          data?.error ||
          `Request failed (${response.status})`
        );
      }
      const items = data.items || [];



setItems(items);

const storage = getStorage();

const urlMap = {};

for (const item of items) {

  urlMap[item.id] = [];

  for (
    const path of (
      item.imagePaths || []
    )
  ) {

    try {

      const url =
        await getDownloadURL(
          ref(storage, path)
        );

      urlMap[item.id].push(url);

    } catch (err) {

      console.error(err);

    }

  }

}

setImageUrlsMap(urlMap);


    } catch (err) {
      console.error("loadImages error:", err);
    } finally {
      setLoading(false);
    }
  };

  const loadGalleries = async () => {
    try {
      const headers = await getAuthHeaders();

      const response = await fetch(
        `${API_BASE}/api/gallery/galleries`,
        { headers }
      );
      const data = await response.json();
      if (!response.ok) {
        throw new Error(
          data?.message ||
          data?.error ||
          `Request failed (${response.status})`
        );
      }
      setGalleries(data.galleries || []);
    } catch (err) {
      console.error("loadGalleries error:", err);
    }
  };

  const loadFilterCategories = async (gId) => {
    try {
      const headers = await getAuthHeaders();

      const response = await fetch(
        `${API_BASE}/api/gallery/categories/${gId}`,
        { headers }
      );
      const data = await response.json();
      if (!response.ok) {
        throw new Error(
          data?.message ||
          data?.error ||
          `Request failed (${response.status})`
        );
      }
      setFilterCategories(data.categories || []);
    } catch (err) {
      console.error("loadFilterCategories error:", err);
    }
  };

  const loadFilterSubcategories = async (cId) => {
    try {
      const headers = await getAuthHeaders();

      const response = await fetch(
        `${API_BASE}/api/gallery/subcategories/${cId}`,
        { headers }
      );
      const data = await response.json();
      if (!response.ok) {
        throw new Error(
          data?.message ||
          data?.error ||
          `Request failed (${response.status})`
        );
      }
      setFilterSubcategories(data.subcategories || []);
    } catch (err) {
      console.error("loadFilterSubcategories error:", err);
    }
  };

  const loadEditCategories = async (gId) => {
    try {
      const headers = await getAuthHeaders();

      const response = await fetch(
        `${API_BASE}/api/gallery/categories/${gId}`,
        { headers }
      );
      const data = await response.json();
      if (!response.ok) {
        throw new Error(
          data?.message ||
          data?.error ||
          `Request failed (${response.status})`
        );
      }
      setEditCategories(data.categories || []);
    } catch (err) {
      console.error("loadEditCategories error:", err);
    }
  };

  const loadEditSubcategories = async (cId) => {
    try {
      const headers = await getAuthHeaders();

      const response = await fetch(
        `${API_BASE}/api/gallery/subcategories/${cId}`,
        { headers }
      );
      const data = await response.json();
      if (!response.ok) {
        throw new Error(
          data?.message ||
          data?.error ||
          `Request failed (${response.status})`
        );
      }
      setEditSubcategories(data.subcategories || []);
    } catch (err) {
      console.error("loadEditSubcategories error:", err);
    }
  };

  const openEdit = async (item) => {

  setEditId(item.id);

  setEditTitle(
    item.title || ""
  );

  setEditDescription(
    item.description || ""
  );

  setEditGalleryId(
    item.galleryId || ""
  );

  await loadEditCategories(
    item.galleryId
  );

  setEditCategoryId(
    item.categoryId || ""
  );

  await loadEditSubcategories(
    item.categoryId
  );

  setEditSubcategoryId(
    item.subcategoryId || ""
  );

};

  const cancelEdit = () => {
    setEditId("");
    setEditTitle("");
    setEditDescription("");
    setEditGalleryId("");
    setEditCategoryId("");
    setEditSubcategoryId("");
    setEditCategories([]);
    setEditSubcategories([]);
  };

  const saveEdit = async (id) => {
    if (!editTitle.trim()) {
      alert("Please enter title");
      return;
    }

    try {
      setSavingEdit(true);
      const headers = await getAuthHeaders();

      const selectedGallery = galleries.find(
        (g) => g.id === editGalleryId
      );
      const selectedCategory = editCategories.find(
        (c) => c.id === editCategoryId
      );
      const selectedSubcategory = editSubcategories.find(
        (s) => s.id === editSubcategoryId
      );

      const response = await fetch(
        `${API_BASE}/api/gallery/update-item/${id}`,
        {
          method: "POST",
          headers: {
            ...headers,
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            title: editTitle.trim(),
            description: editDescription.trim(),
            galleryId: editGalleryId,
            galleryName: selectedGallery?.name || "",
            categoryId: editCategoryId,
            categoryName: selectedCategory?.name || "",
            subcategoryId: editSubcategoryId,
            subcategoryName: selectedSubcategory?.name || ""
          })
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data?.message || data?.error || "Update failed"
        );
      }

      cancelEdit();
      loadImages();

    } catch (err) {
      console.error("saveEdit error:", err);
      alert(err?.message || "Failed to save changes");
    } finally {
      setSavingEdit(false);
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this upload?")) return;

    try {
      const headers = await getAuthHeaders();

      const response = await fetch(
        `${API_BASE}/api/gallery/delete/${id}`,
        {
          method: "DELETE",
          headers
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data?.message || data?.error || "Delete failed"
        );
      }

      loadImages();

    } catch (err) {
      console.error("remove error:", err);
      alert(err?.message || "Failed to delete upload");
    }
  };

  const carouselPrev = (itemId, total) => {
    setCarouselIndex((prev) => ({
      ...prev,
      [itemId]: ((prev[itemId] || 0) - 1 + total) % total
    }));
  };

  const carouselNext = (itemId, total) => {
    setCarouselIndex((prev) => ({
      ...prev,
      [itemId]: ((prev[itemId] || 0) + 1) % total
    }));
  };

  const formatDate = (ts) => {
    if (!ts) return "";
    try {
      const d = ts?.seconds
        ? new Date(ts.seconds * 1000)
        : new Date(ts);
      return d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric"
      });
    } catch {
      return "";
    }
  };

  const getStatusStyle = (status) => {
    if (status === "approved") return { bg: "#DCFCE7", color: "#166534" };
    if (status === "rejected") return { bg: "#FEE2E2", color: "#991B1B" };
    return { bg: "#FEF3C7", color: "#92400E" };
  };

  // Filtered items
  const filteredItems = items.filter((item) => {
    if (galleryFilter && item.galleryId !== galleryFilter) return false;
    if (categoryFilter && item.categoryId !== categoryFilter) return false;
    if (subcategoryFilter && item.subcategoryId !== subcategoryFilter) return false;
	if (statusFilter && item.status !== statusFilter) 
	{  return false; }
	
	
	
    if (search.trim()) {
      const q = search.trim().toLowerCase();
      const haystack = [
        item.title,
        item.galleryName,
        item.categoryName,
        item.subcategoryName
      ]
        .join(" ")
        .toLowerCase();
      if (!haystack.includes(q)) return false;
    }
    return true;
  });

  const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    borderRadius: 10,
    border: "1px solid #d1d5db",
    marginBottom: 10,
    boxSizing: "border-box",
    fontSize: 14
  };

  const selectStyle = {
    ...inputStyle,
    background: "#fff"
  };

  const labelStyle = {
    fontSize: 12,
    fontWeight: 600,
    color: "#6b7280",
    marginBottom: 4,
    display: "block"
  };

  if (loading) {
    return <h3>Loading uploads...</h3>;
  }

  return (
    <div>

      <h2>My Uploads</h2>

      <p style={{ color: "#6b7280", marginBottom: 20 }}>
        Manage your uploaded drawings, worksheets, charts, coloring pages and educational content.
      </p>

      {/* Filters */}
      <div
        style={{
          background: "#f8fafc",
          border: "1px solid #e5e7eb",
          borderRadius: 12,
          padding: 16,
          marginBottom: 20,
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill,minmax(200px,1fr))",
          gap: 12
        }}
      >
        {/* Search */}
        <div>
          <span style={labelStyle}>Search</span>
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Title, gallery, category..."
            style={inputStyle}
          />
        </div>

        {/* Gallery filter */}
        <div>
          <span style={labelStyle}>Gallery</span>
          <select
            value={galleryFilter}
            onChange={(e) => {
              setGalleryFilter(e.target.value);
              setCategoryFilter("");
              setSubcategoryFilter("");
            }}
            style={selectStyle}
          >
            <option value="">All Galleries</option>
            {galleries.map((g) => (
              <option key={g.id} value={g.id}>
                {g.name}
              </option>
            ))}
          </select>
        </div>

        {/* Category filter */}
        <div>
          <span style={labelStyle}>Category</span>
          <select
            value={categoryFilter}
            onChange={(e) => {
              setCategoryFilter(e.target.value);
              setSubcategoryFilter("");
            }}
            disabled={!galleryFilter}
            style={{
              ...selectStyle,
              opacity: !galleryFilter ? 0.5 : 1
            }}
          >
            <option value="">All Categories</option>
            {filterCategories.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </select>
        </div>

        {/* Subcategory filter */}
        <div>
          <span style={labelStyle}>Subcategory</span>
          <select
            value={subcategoryFilter}
            onChange={(e) => setSubcategoryFilter(e.target.value)}
            disabled={!categoryFilter}
            style={{
              ...selectStyle,
              opacity: !categoryFilter ? 0.5 : 1
            }}
          >
            <option value="">All Subcategories</option>
            {filterSubcategories.map((s) => (
              <option key={s.id} value={s.id}>
                {s.name}
              </option>
            ))}
          </select>
        </div>
      </div>



<div>
  <span style={labelStyle}>
    Status
  </span>

  <select
    value={statusFilter}
    onChange={(e) =>
      setStatusFilter(
        e.target.value
      )
    }
    style={selectStyle}
  >
    <option value="">
      All Statuses
    </option>

    <option value="pending">
      Pending
    </option>

    <option value="approved">
      Approved
    </option>

    <option value="rejected">
      Rejected
    </option>
  </select>
</div>


      {/* Result count */}
      <p style={{ color: "#6b7280", fontSize: 13, marginBottom: 16 }}>
        Showing {filteredItems.length} of {items.length} uploads
      </p>

      {filteredItems.length === 0 && (
        <div
          style={{
            padding: 30,
            textAlign: "center",
            background: "#fff",
            borderRadius: 16
          }}
        >
          {items.length === 0
            ? "No uploads found."
            : "No uploads match your filters."}
        </div>
      )}

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fill,minmax(300px,1fr))",
          gap: 20
        }}
      >
        {filteredItems.map((item) => {

          const statusStyle = getStatusStyle(item.status);
          const images =
  imageUrlsMap[item.id] || [];
          const currentImg = carouselIndex[item.id] || 0;
          const isEditing = editId === item.id;
		  

          return (
            <div
              key={item.id}
              style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: 16,
                overflow: "hidden"
              }}
            >
              {/* Image carousel */}
              <div style={{ position: "relative" }}>
                <img
                  src={images[currentImg]}
                  alt=""
                  style={{
                    width: "100%",
                    height: 220,
                    objectFit: "cover",
                    display: "block"
                  }}
                />

                {images.length > 1 && (
                  <>
                    <button
                      onClick={() => carouselPrev(item.id, images.length)}
                      style={{
                        position: "absolute",
                        left: 8,
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "rgba(0,0,0,0.45)",
                        color: "#fff",
                        border: "none",
                        borderRadius: "50%",
                        width: 32,
                        height: 32,
                        cursor: "pointer",
                        fontSize: 16,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                    >
                      ‹
                    </button>

                    <button
                      onClick={() => carouselNext(item.id, images.length)}
                      style={{
                        position: "absolute",
                        right: 8,
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "rgba(0,0,0,0.45)",
                        color: "#fff",
                        border: "none",
                        borderRadius: "50%",
                        width: 32,
                        height: 32,
                        cursor: "pointer",
                        fontSize: 16,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                    >
                      ›
                    </button>

                    <div
                      style={{
                        position: "absolute",
                        bottom: 8,
                        right: 10,
                        background: "rgba(0,0,0,0.5)",
                        color: "#fff",
                        fontSize: 12,
                        padding: "2px 8px",
                        borderRadius: 999
                      }}
                    >
                      {currentImg + 1} / {images.length}
                    </div>
                  </>
                )}
              </div>

              <div style={{ padding: 15 }}>

                {/* Status badge */}
                <div
                  style={{
                    display: "inline-block",
                    padding: "5px 12px",
                    borderRadius: 999,
                    background: statusStyle.bg,
                    color: statusStyle.color,
                    fontWeight: 700,
                    fontSize: 13,
                    marginBottom: 10
                  }}
                >
                  {(item.status || "pending").charAt(0).toUpperCase() +
                    (item.status || "pending").slice(1)}
                </div>

                {/* Rejection reason */}
                {item.status === "rejected" && item.rejectionReason && (
                  <div
                    style={{
                      background: "#FEE2E2",
                      border: "1px solid #FCA5A5",
                      borderRadius: 8,
                      padding: "8px 12px",
                      fontSize: 13,
                      color: "#991B1B",
                      marginBottom: 10
                    }}
                  >
                    <strong>Reason:</strong> {item.rejectionReason}
                  </div>
                )}

                {/* Gallery / Category / Subcategory breadcrumb */}
                <div
                  style={{
                    fontSize: 12,
                    color: "#9ca3af",
                    marginBottom: 10,
                    lineHeight: 1.8
                  }}
                >
                  {item.galleryName && (
                    <div>
                      <span style={{ fontWeight: 600, color: "#6b7280" }}>Gallery: </span>
                      {item.galleryName}
                    </div>
                  )}
                  {item.categoryName && (
                    <div>
                      <span style={{ fontWeight: 600, color: "#6b7280" }}>Category: </span>
                      {item.categoryName}
                    </div>
                  )}
                  {item.subcategoryName && (
                    <div>
                      <span style={{ fontWeight: 600, color: "#6b7280" }}>Subcategory: </span>
                      {item.subcategoryName}
                    </div>
                  )}
                </div>

                {/* Edit form */}
                {isEditing ? (
                  <div>
                    <label style={labelStyle}>Title</label>
                    <input
                      value={editTitle}
                      onChange={(e) => setEditTitle(e.target.value)}
                      style={inputStyle}
                      placeholder="Title"
                    />

                    <label style={labelStyle}>Description</label>
                    <textarea
                      value={editDescription}
                      onChange={(e) => setEditDescription(e.target.value)}
                      rows={3}
                      style={{
                        ...inputStyle,
                        resize: "vertical"
                      }}
                      placeholder="Description"
                    />

                    <label style={labelStyle}>Gallery</label>
                    <select
                      value={editGalleryId}
                      onChange={(e) => setEditGalleryId(e.target.value)}
                      style={selectStyle}
                    >
                      <option value="">Select Gallery</option>
                      {galleries.map((g) => (
                        <option key={g.id} value={g.id}>
                          {g.name}
                        </option>
                      ))}
                    </select>

                    <label style={labelStyle}>Category</label>
                    <select
                      value={editCategoryId}
                      onChange={(e) => setEditCategoryId(e.target.value)}
                      disabled={!editGalleryId}
                      style={{
                        ...selectStyle,
                        opacity: !editGalleryId ? 0.5 : 1
                      }}
                    >
                      <option value="">Select Category</option>
                      {editCategories.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.name}
                        </option>
                      ))}
                    </select>

                    <label style={labelStyle}>Subcategory</label>
                    <select
                      value={editSubcategoryId}
                      onChange={(e) => setEditSubcategoryId(e.target.value)}
                      disabled={!editCategoryId}
                      style={{
                        ...selectStyle,
                        opacity: !editCategoryId ? 0.5 : 1
                      }}
                    >
                      <option value="">Select Subcategory</option>
                      {editSubcategories.map((s) => (
                        <option key={s.id} value={s.id}>
                          {s.name}
                        </option>
                      ))}
                    </select>

                    <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
                      <button
                        onClick={() => saveEdit(item.id)}
                        disabled={savingEdit}
                        style={{
                          flex: 1,
                          padding: "10px 0",
                          border: "none",
                          borderRadius: 10,
                          background: "#2563eb",
                          color: "#fff",
                          fontWeight: 700,
                          cursor: savingEdit ? "not-allowed" : "pointer",
                          opacity: savingEdit ? 0.7 : 1
                        }}
                      >
                        {savingEdit ? "Saving..." : "Save"}
                      </button>

                      <button
                        onClick={cancelEdit}
                        style={{
                          flex: 1,
                          padding: "10px 0",
                          border: "1px solid #d1d5db",
                          borderRadius: 10,
                          background: "#fff",
                          color: "#374151",
                          fontWeight: 600,
                          cursor: "pointer"
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>

                ) : (

                  <div>
                    <h4 style={{ margin: "0 0 6px 0", fontSize: 15 }}>
                      {item.title}
                    </h4>
{item.userName && (

  <div
    style={{
      fontSize: 12,
      color: "#6b7280",
      marginBottom: 6
    }}
  >
    Uploaded By:
    {" "}
    {item.userName}
  </div>

)}
                    {item.description && (
                      <p
                        style={{
                          color: "#6b7280",
                          fontSize: 13,
                          margin: "0 0 10px 0",
                          lineHeight: 1.5
                        }}
                      >
                        {item.description}
                      </p>
                    )}

                    <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
                      <button
                        onClick={() => openEdit(item)}
                        style={{
                          padding: "8px 14px",
                          border: "1px solid #d1d5db",
                          borderRadius: 8,
                          background: "#fff",
                          cursor: "pointer",
                          fontSize: 13,
                          fontWeight: 600
                        }}
                      >
                        ✏️ Edit
                      </button>

                      <button
                        onClick={() => remove(item.id)}
                        style={{
                          padding: "8px 14px",
                          border: "1px solid #FCA5A5",
                          borderRadius: 8,
                          background: "#FEF2F2",
                          color: "#DC2626",
                          cursor: "pointer",
                          fontSize: 13,
                          fontWeight: 600
                        }}
                      >
                        🗑 Delete
                      </button>

                      
                    </div>
                  </div>

                )}

                <hr style={{ border: "none", borderTop: "1px solid #f3f4f6", margin: "10px 0" }} />

              

                {/* Meta row */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 12,
                    color: "#9ca3af"
                  }}
                >
                  {item.createdAt && (
                    <span>📅 {formatDate(item.createdAt)}</span>
                  )}
                  {images.length > 0 && (
                    <span>🖼 {images.length} image{images.length !== 1 ? "s" : ""}</span>
                  )}
                </div>

              </div>
            </div>
          );
        })}
      </div>

    </div>
  );
}
